import React from 'react';
import { Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const DashboardCallLogs = () => {
  const sampleLogs = [
    { id: 1, date: '2023-06-01', time: '09:30 AM', duration: '5m 23s', caller: 'John Doe', outcome: 'Resolved' },
    { id: 2, date: '2023-06-01', time: '11:45 AM', duration: '3m 12s', caller: 'Jane Smith', outcome: 'Transferred' },
    { id: 3, date: '2023-06-02', time: '02:15 PM', duration: '7m 48s', caller: 'Bob Johnson', outcome: 'Resolved' },
  ];

  return (
    <Paper elevation={0}>
      <Typography variant="h4" gutterBottom>Dashboard Call Logs</Typography>
      <Typography paragraph>
        The Call Logs section in your Dashboard provides a comprehensive record of all AI Talker interactions. 
        This feature allows you to review past conversations, analyze patterns, and gain insights into your AI Talker's performance.
      </Typography>
      <Typography variant="h6" gutterBottom>Key Features:</Typography>
      <Typography paragraph>
        1. <strong>Detailed Records:</strong> Each log entry includes essential information such as date, time, duration, caller details, and interaction outcome.
      </Typography>
      <Typography paragraph>
        2. <strong>Search and Filter:</strong> Easily find specific interactions using advanced search and filter options.
      </Typography>
      <Typography paragraph>
        3. <strong>Export Functionality:</strong> Export logs in various formats (CSV, PDF) for further analysis or reporting.
      </Typography>
      <Typography paragraph>
        4. <strong>Interaction Playback:</strong> Listen to recordings or read transcripts of past interactions for quality assurance and training purposes.
      </Typography>
      <Typography variant="h6" style={{ marginTop: '20px' }}>Sample Call Log:</Typography>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Caller</TableCell>
              <TableCell>Outcome</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sampleLogs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>{log.date}</TableCell>
                <TableCell>{log.time}</TableCell>
                <TableCell>{log.duration}</TableCell>
                <TableCell>{log.caller}</TableCell>
                <TableCell>{log.outcome}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="h6" style={{ marginTop: '20px' }}>Using Call Logs:</Typography>
      <Typography paragraph>
        1. Navigate to the Call Logs tab in your Dashboard.
      </Typography>
      <Typography paragraph>
        2. Use the date range selector to view logs for a specific period.
      </Typography>
      <Typography paragraph>
        3. Click on any log entry to view more details, including full transcripts or recordings if available.
      </Typography>
      <Typography paragraph>
        4. Use the search and filter options to find specific interactions based on criteria like caller, outcome, or duration.
      </Typography>
      <Typography paragraph>
        5. Export selected logs or generate reports for further analysis or record-keeping.
      </Typography>
      <Typography paragraph>
        Call Logs are an invaluable tool for understanding your AI Talker's performance, identifying areas for improvement, 
        and maintaining a record of all AI-powered interactions for compliance and quality assurance purposes.
      </Typography>
    </Paper>
  );
};

export default DashboardCallLogs;
